// extracted by mini-css-extract-plugin
module.exports = {"fieldLabel":"FieldLabel_fieldLabel__39Jlf","requiredTag":"FieldLabel_requiredTag__4aaRx"};